import Grid from '@mui/material/Grid';
import { SwishPaymentData } from 'common-models';

import { FC } from "react";
import PageIsLoading from "src/components/PageIsLoading";


type SwishAppButtonProps = {
    swishPayment: SwishPaymentData,
}

const SwishAppButton: FC<SwishAppButtonProps> = ({ swishPayment }) => {

    const getReturnUrl = () => {
        const location = window.location;
        return `${location.protocol}//${location.host}${location.port.length > 0 ? `:${location.port}` : ''}${location.pathname}?`
    }

    return (

        <Grid
            size={{ xs: 12, sm: 12, lg: 4 }}
            className='swish-link-frame'>
            {
                swishPayment
                    ? <a href={`swish://paymentrequest?token=${swishPayment.paymentRequestToken}&callbackurl=${getReturnUrl()}`}>Klicka här för att starta Swish-appen och genomföra betalningen. Du kan avbryta betalningen i appen.</a>
                    : <PageIsLoading />
            }
        </Grid>

    );
};

export { SwishAppButton };
